/* import __COLOCATED_TEMPLATE__ from './image-text-inserter.hbs.js'; */
import Component from '@glimmer/component';
/* eslint-disable-next-line ember/no-empty-glimmer-component-classes */
export default class ImageTextInserter extends Component {}